/*
    mark_as_completed:
      Initial Value = 0
      After updated the status = 1
      After the mark-as-completed API call = 2
*/
export const TaskCompleteStatusEnum = {
    INITIAL: {
        key: 0,
    },
    UPDATED: {
        key: 1,
    },
    COMPLETED: {
        key: 2,
    }
}